module.exports = __webpack_public_path__ + "static/media/geo.9549f5be.svg";